import type { Requests } from "../common/request.common";
import type { WhatsAppInvoiceResponseTypes } from "../common/response.common";
import { get, post, postEmpty } from "./common";

export const whatsAppInvoice = {
    record(data: typeof Requests.WhatsAppInvoice.Record.Input) {
        return post<typeof data, WhatsAppInvoiceResponseTypes.Record>(
            `/whatsapp-invoice/record`,
            data,
        );
    },
    obtain(id: string) {
        return get<WhatsAppInvoiceResponseTypes.Obtain>(`/whatsapp-invoice/obtain/${id}`);
    },
    payment(id: string, data: typeof Requests.WhatsAppInvoice.Payment.Input) {
        return post<typeof data>(`/whatsapp-invoice/payment/${id}`, data);
    },
    waive(id: string) {
        return postEmpty(`/whatsapp-invoice/waive/${id}`);
    },
    revert(id: string) {
        return postEmpty(`/whatsapp-invoice/revert/${id}`);
    },
};
